// Page copy for the redesigned Studio. Keep enUS and zhCN structurally identical.
export const enUS = {
  statusFilter: 'Avatar status',
  loadingAvatars: 'Loading avatars',
  createCard: 'Create Avatar',
  createCardDescription: 'Start from a photo',
  emptyTitle: 'Create your first avatar',
  emptyBody: 'Start with a clear photo of your avatar',
  filteredEmptyTitle: 'No avatars with this status',
  filteredEmptyBody: 'Choose another status or view all your avatars',
  showAll: 'Show all avatars',
  edit: 'Edit',
  actionsFor: 'More actions for {name}',
  copyId: 'Copy {name} avatar ID',
  copiedId: 'Copied {name} avatar ID',
  copied: 'Copied',
  generating: 'Generating',
  failed: 'Failed',
  failureDetails: 'Why creation failed',
  failureDetailsFor: 'Why it failed: {name}',
  viewFailureDetails: 'Why it failed',
  estimatedProgress: 'Estimated progress: {progress}%',
  stage: {
    submitted: 'Submitted',
    preparing: 'Preparing',
    building: 'Building',
    finalizing: 'Finalizing',
    ready: 'Ready',
    failed: 'Failed',
  },
  elapsed: {
    justStarted: 'Just started',
    minutes: '{count}m elapsed',
    hours: '{count}h elapsed',
  },
  failureSummary: {
    processing_error: 'Creation error',
    content_policy: 'Image rejected',
    input_invalid: 'Check image',
    input_unavailable: 'Image issue',
    model_no_output: 'No result',
    provider_busy: 'Service busy',
    provider_configuration: 'Service issue',
    output_invalid: 'Invalid result',
  },
  generationProgress: '{name} generation',
  detail: {
    back: 'Back to Custom Avatars',
    avatarId: 'Avatar ID',
    preview: 'Preview',
    voice: 'Voice',
    changeVoice: 'Change voice',
    background: 'Background',
    showBackground: 'Show background',
    backgroundNote: 'Only affects this preview',
    integrationGuide: 'Integration guide',
    download: 'Download',
    effects: 'Avatar effects',
    effectsStatus: '3 adjustments',
    noBackground: 'No background asset',
    effectsDirty: 'Unsaved changes',
    revert: 'Revert changes',
    saveEffects: 'Save effects',
    saving: 'Saving…',
    placement: 'Avatar placement',
    resetPlacement: 'Reset',
    unavailable: 'This avatar is unavailable',
  },
}

export const zhCN = {
  statusFilter: '人物状态',
  loadingAvatars: '正在加载人物',
  createCard: '创建人物',
  createCardDescription: '从一张照片开始',
  emptyTitle: '创建你的第一个人物',
  emptyBody: '从一张清晰的人物照片开始',
  filteredEmptyTitle: '当前状态下暂无人物',
  filteredEmptyBody: '请选择其他状态，或查看全部人物',
  showAll: '查看全部人物',
  edit: '编辑',
  actionsFor: '{name} 的更多操作',
  copyId: '复制 {name} 的人物 ID',
  copiedId: '已复制 {name} 的人物 ID',
  copied: '已复制',
  generating: '生成中',
  failed: '失败',
  failureDetails: '创建失败原因',
  failureDetailsFor: '查看 {name} 的失败原因',
  viewFailureDetails: '查看原因',
  estimatedProgress: '预计进度：{progress}%',
  stage: {
    submitted: '已提交',
    preparing: '准备中',
    building: '构建中',
    finalizing: '收尾中',
    ready: '已完成',
    failed: '失败',
  },
  elapsed: {
    justStarted: '刚刚开始',
    minutes: '已用时 {count} 分钟',
    hours: '已用时 {count} 小时',
  },
  failureSummary: {
    processing_error: '处理出错',
    content_policy: '图片不符合要求',
    input_invalid: '请检查图片',
    input_unavailable: '图片暂不可用',
    model_no_output: '未生成可用结果',
    provider_busy: '服务繁忙',
    provider_configuration: '服务暂不可用',
    output_invalid: '生成结果无效',
  },
  generationProgress: '{name} 生成进度',
  detail: {
    back: '返回自定义人物',
    avatarId: '人物 ID',
    preview: '预览',
    voice: '声音',
    changeVoice: '更换声音',
    background: '背景',
    showBackground: '显示背景',
    backgroundNote: '仅影响当前预览',
    integrationGuide: '接入指南',
    download: '下载',
    effects: '人物效果',
    effectsStatus: '3 项调节',
    noBackground: '暂无背景素材',
    effectsDirty: '有未保存修改',
    revert: '恢复修改',
    saveEffects: '保存效果',
    saving: '保存中…',
    placement: '人物位置',
    resetPlacement: '重置',
    unavailable: '该人物暂不可用',
  },
}
